import ufeApi from 'services/api/ufeApi';
import userUtils from 'utils/User';

// https://confluence.sephora.com/wiki/display/ILLUMINATE/Switch+Preferred+Store+API

function switchPreferredStore(preferredStoreId, customerSelected) {
    const isUserAnonymous = userUtils.isAnonymous();

    if (isUserAnonymous) {
        return Promise.resolve();
    }

    const url = '/gway/v2/users/profiles/preferredStore';

    return ufeApi
        .makeRequest(url, {
            method: 'POST',
            body: JSON.stringify({
                preferredStoreId: preferredStoreId,
                customerSelected: customerSelected
            })
        })
        .then(data => (data.errorCode ? Promise.reject(data) : data));
}

export default switchPreferredStore;
